const itemParameterOrder = [
	'name',
	'icon',
	'description',
	'hint',
	'type',
	'group',
	'element',
	'novelty type',
	'novelty-id',
	'skin type',
	'rarity',
	'level',
	'skin',
	'set',
	'miniature set',
	'miniature id',
	'slots',
	'property',
	'material',
	'hue',
	'kit',
	'color-cloth',
	'color-leather',
	'color-metal',
	'color-fur',
	'color-id',
	'prefix',
	'variables',
	'bonus',
	'uslot',
	'facts',
	'recharge',
	'infusion slot',
	'infused',
	'attuned',
	'minimum power',
	'maximum power',
	'defense',
	'class',
	'race',
	'cost',
	'value',
	'unique',
	'bound',
	'salvage',
	'collection',
	'id',
	'decoration id',
	'gallery',
	'requires',
	'status'
];

const recipeParameterOrder = [
	'source',
	'sheet',
	'disciplines',
	'rating',
	'type',
	'ingredients',
	'id'
]

const skinParameterOrder = [
	'name',
	'icon',
	'description',
	'hint',
	'collection',
	'type',
	'class',
	'set',
	'damage type',
	'dye channels',
	'id',
	'gallery'
]

const achievementParameterOrder = [
	'name',
	'page',
	'description',
	'flavor',
	'type',
	'hidden',
	'tiers',
	'cap',
	'reward',
	'quantity',
	'title',
	'prerequisite',
	'mastery',
	'mastery id',
	'coins',
	'objectives',
	'collection',
	'id'
]

//
/////////////

module.exports = { achievementParameterOrder, skinParameterOrder, recipeParameterOrder, itemParameterOrder  };
